const $ = require('jquery');

let entityMap = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#39;',
	'/': '&#x2F;',
	'`': '&#x60;',
	'=': '&#x3D;'
};
  
/** From mustache.js */
function escapeHtml (string) {
	return String(string).replace(/[&<>"'`=\/]/g, function (s) {
        return entityMap[s];
	});
}

/**
 * Devuelve como numérico el valor de un input o select
 * @param {DOMElement} element
 * @returns {number}
 */
function asNumber(element) {
	return parseInt($(element).val(), 10) || null;
}

const regexColumn = /col-(xs-|sm-|md-|lg-){0,1}([0-9]{1,2})/;
const regexColumnOffset = /offset-(xs|sm|md|lg)-([0-9]{1,2})/;
const regexSpaces = /\s+/;

function calculateClassesFromLabel($label) {
    let colClass = '';
    let offsetClass = '';
	
	let cssClassAttr = $label.attr("class");
	if (cssClassAttr) {
		let cssClasses = cssClassAttr.split(regexSpaces);
		let cssClass = cssClasses.find(function (value) {
            return regexColumn.test(value);
        });
		if (cssClass) {
            let [, gridTier, cols] = cssClass.match(regexColumn);
            colClass = 'col-' + (gridTier ? gridTier : '') + (12 - cols);
            offsetClass = 'offset-' + (gridTier ? gridTier  : '') + cols;
		}
    }
	
	return {
		colClass: colClass,
		offsetClass: offsetClass
	};
}

function calculateClassesFromField($field, options) {
    let colClass = '';
    let offsetClass = '';
	
	let cssClassAttr = $field.closest('div').attr("class");
	if (cssClassAttr && !options.ifNoLabelNoClass) {
		let cssClasses = cssClassAttr.split(regexSpaces);
		
		let cssColClass = cssClasses.find(function (value) {
            return regexColumn.test(value);
        });
		let cssOffsetClass = cssClasses.find(function (value) {
            return regexColumnOffset.test(value);
        }); 
		
		colClass = cssColClass || '';
		offsetClass = cssOffsetClass || '';
    }
	
	return {
		colClass: colClass,
		offsetClass: offsetClass
	};
}

function calculateErrorClasses($field, options) {
	let id = $.escapeSelector($field.attr('id'));
	let $label = $('label[for="' + id + '"]');
	if (!$label.length) {
		let attrName = $field.attr('name');
		if (attrName) {
			let name = $.escapeSelector(attrName.replace(/\[|\]/g, ''));
			$label = $('label[for="' + name + '"]');
		}
	}
	let classes;
	if ($label.length) {
		classes = calculateClassesFromLabel($label);
	} else {
		classes = calculateClassesFromField($field, options);
	}
	return classes;
}

/**
 * Limpia los mensajes de un campo. 
 * 
 * @param parent
 * @param type
 * @returns
 */
function removeFieldMsgType(parent, type) {
	let $errors;
	if (parent) {
		$errors = $(parent).find('.has-' + type).add(parent);
	} else {
		$errors = $('.has-' + type);
	}
	$errors.removeClass('has-' + type).find('.field-' + type).remove();
	
	if (parent && type === 'error' && $errors.length > 0) {
		$errors.each(function () {
			if ($(this).hasClass('form-group')) {
				let $field = $(this).find('input,select,textarea');
//    			publish('aemps.error.removed', { field: $field });
			}
		});
	}
}

/**
 * Limpia los mensajes de error. 
 * Se debería de utilizar antes de mostrar los errores, para eliminar los existentes previamente.
 * 
 * @param parent
 * @returns
 */
function removeErrors(parent) {
	removeFieldMsgType(parent, 'error');
}

/**
 * Muestra los errores de un formulario.
 * 
 * @param errors [{ field: "nombre del campo", message: "mensaje de error", code: "código del mensaje" }]
 * @param options {scroll: boolean, parent: 'selector'} 
 * @returns
 */
function showErrors(errors, options) {
	let optionsConfig = options || { scroll: true, parent: null, ifNoLabelNoClass: false };
	let errorsAdded = [];
    errors.forEach(function (error) {
    	if (!error.field) {
    		return;
    	}
		let name = $.escapeSelector(error.field);
		let $field = null;
		if (optionsConfig.parent) {
			$field = $(optionsConfig.parent).find('[name=' + name + ']');
		} else {
			$field = $('[name=' + name + ']');
		}
		if (!$field.length) {
			$field = $('[data-error-field=' + name + ']');
		}
    	let $parent = $field.closest('div.form-group,fieldset.form-group');
    	if (!$field.length) {
    		$field = $('#' + name);
    		$parent = $field.closest('*');
    	}
    	let classes = calculateErrorClasses($field, optionsConfig);

    	$parent.prepend('<div class="field-error text-danger ' + classes.colClass + ' ' + classes.offsetClass + '"><i class="fa fa-exclamation-circle"></i> ' + escapeHtml(error.message) + '</div>');
    	$parent.addClass('has-error');
    	
    	errorsAdded.push({ field: $field });
		
		function removeErrorMsg() {
			if ($parent.hasClass('has-error')) {
				$parent.removeClass('has-error');
				$parent.find('.field-error').remove();
				//publish('aemps.error.removed', { field: $field });
			}
		}
		
		let cleanEvents = ['change', 'keydown'];
		if ($field.attr('data-error-field')) {
			cleanEvents.push('click');
		}
		$field.one(cleanEvents.join(' '), removeErrorMsg);
    });
    //if (errorsAdded.length > 0) {
    //	publish('aemps.error.added', { fields: errorsAdded, options: optionsConfig});
    //}
}

var icons = {
	'error': 'exclamation-circle',
	'warning': 'exclamation-triangle',
	'info': 'info-circle',
};

/**
 * 
 * @param warnings [{ field: "nombre del campo", message: "mensaje de advertencia", code: "código del mensaje" }] 
 * @returns
 */
function showFieldMsg(messages, type) {
    messages.forEach(function (message) {
    	if (!message.field) {
    		return;
    	}
    	let name = $.escapeSelector(message.field);
    	let $field = $('[name=' + name + ']');
    	let $parent = $field.closest('div.form-group');
    	if (!$field.length) {
    		$field = $('#' + name);
    		$parent = $field.closest('*');
    	}
    	let classes = calculateErrorClasses($field);

    	let htmlMessage = 
    		'<div class="field-' + type + ' text-' + type + ' ' + classes.colClass + ' ' + classes.offsetClass + '">' + 
    		'  <i class="fa fa-' + icons[type] + '"></i> ' + 
    		message.message +
    		'<button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
    		'</div>';
    	       	
    	$parent.prepend(htmlMessage);
    	$parent.addClass('has-' + type);
    	$field.one('change keydown', function () {
    		$parent.removeClass('has-' + type);
    		$parent.find('.field-' + type).remove();
    	});
		$parent.on('click', '.field-error button.close, .field-warning button.close, .field-info button.close', function () {
    		$parent.removeClass('has-' + type);
    		$parent.find('.field-' + type).remove();
		});
    	
    });
}

function showWarning(messages) {
	return showFieldMsg(messages, 'warning');
}

function showInfo(messages) {
	return showFieldMsg(messages, 'info');
}

function removeWarning(parent) {
	removeFieldMsgType(parent, 'warning');
}

function removeInfo(parent) {
	removeFieldMsgType(parent, 'info');
}

/**
 * Elimina mensajes de un campo.
 * @param parent
 * @returns
 */
function removeFieldMsg(selector) {
	let $parent = $(selector).closest('div.form-group');
	removeErrors($parent);
	removeFieldMsgType($parent, 'warning');
	removeFieldMsgType($parent, 'info');
}


/** Usado por createFormModel para detectar campos que deben meterse en un array (name[0])*/ 
var regexArray = /(.+)\[(\d+)\]$/;

/**
 * Genera un objeto que representa el estado de todos los campos del formulario.
 * @param formSelector
 * @returns
 */
function createFormModel(formSelector) {
	/**
	 * Recorre todos los segmentos del nombre del atributo.
	 */
	function visit(base, name, value) {
		// TODO ¿si se trata de un multi-select o varios checkbuttons con el mismo nombre...?
		let segments = name.split('.');
		if (segments.length === 1) {
			base[name] = value;
		} else {
			let firstSegment = segments[0];
			let splitArray = firstSegment.match(regexArray); 
			if (splitArray) {
				let name = splitArray[1];
				let index = splitArray[2];
				base[name] = base[name] || [];
				base[name][index] = base[name][index] || {};
				visit(base[name][index], segments.slice(1).join('.'), value);
			} else {
				base[firstSegment] = base[firstSegment] || {};
				visit(base[firstSegment], segments.slice(1).join('.'), value);
			}
		}
	}
	
	let base = {};
	let unchecked = $.makeArray($('[type=checkbox][name]:not(:checked)').map(
			function () { 
				return { 
					name: $(this).attr('name'), 
					value: false
				};
			}
		));
	let formData = $(formSelector).serializeArray().concat(unchecked);
	formData.forEach(function (field) {
		let name = field.name;
		let value = field.value;
		visit(base, name, value);
	});
	
	return base;
}

/**
 * 
 * @param {object} formModel 
 * @param {object} specialFields key = 'fieldname', value = function (value)
 * @param {function} callback 
 * @param {string} initialPrefix 
 */
function modelVisitor(formModel, specialFields, callback, initialPrefix) {
	function visit(prefix, model) {
        for (let field in model) {
        	if (model.hasOwnProperty(field)) {
        		var handler = specialFields[field]; 
        		if (handler) {
        			handler(model[field]);
        		} else {
        			if (Array.isArray(model[field])) {
        				model[field].forEach(function (item, index) {
        					visit(prefix + field + '[' + index + '].', model[field][index]);
        				});
        			} else if (typeof model[field] === 'object') {
        				visit(prefix + field + '.', model[field]);
        			} else {
        				callback(prefix + field, model[field]);
        			}
        		}
            }
        }
	}
	
	visit(initialPrefix || '', formModel);
}

function setValue(field, value) {
	let $field = $('[name="' + $.escapeSelector(field) + '"]');
	let type = $field.attr('type');
	switch (type) {
		case 'checkbox':
		case 'radio':
			$field.each(function () {
				this.checked = (this.value === value);
			});
			break;
		default:
			$field.val(value);
	}
}

/**
 * Restaura el formulario a partir del modelo.
 * 
 * @param formModel
 * @param specialFields
 * @returns
 */
function restoreFormModel(formModel, specialFields) {
	modelVisitor(formModel, specialFields, setValue);
}

/**
 * Gestiona la navegación entre "páginas".
 * 
 * @param config
 * @returns
 */
function Router(config) {
	this.handlers = config.handlers;
	this.count = 1;
	
	if (window.history.state) {
		console.log('%chistory.state', 'background-color: orange; color: black');
		console.log(window.history.state);
		this._restoreState(window.history.state, true);
	} else {
		var state = sessionStorage.getItem('state');
		if (state) {
			console.log('%csessionStorage state', 'background-color: green; color: black');
			sessionStorage.removeItem('state');
			state = JSON.parse(state);
			this._restoreState(state, true);
		}
		
		this._replaceState(state);
	}
	
	let self = this;
	$(window).on('popstate', function () {
		self._popState();
	});
}

Router.prototype = {
	_popState: function () {
		console.log('%cpopstate <- ', 'background-color: magenta; color: black');
		console.log(history.state);
		if (history.state) {
			this._restoreState(history.state, false);
		}
	},

	_restoreState: function (state, refresh) {
		this.handlers.forEach(function (handler) {
			handler.restore(state[handler.name], refresh);
		});
	},
	
	_replaceState: function (newState) {
		console.log('%creplaceState', 'background-color: cyan; color: black');
		let state = newState || this._createState();
		if (window.history.replaceState) {
			window.history.replaceState(state, "");
			console.log(state);
		}
	},
		
	_createState: function () {
		let state = {
			id: this.count++
		};
		this.handlers.forEach(function (handler) {
			state[handler.name] = handler.create();
		});
		return state;
	},
		
	pushState: function () {
		console.log('%cpushState', 'background-color: yellow; color: black');
		let state = this._createState();
		if (window.history.pushState) {
			window.history.pushState(state, "");
			console.log(state);
		}
	}
};

let loader = (function () {
	function loaderTag(size, persistClass) {
		return '<div class="ui loader ajax ' + (size || '') + ' ' + persistClass + '">' +
    			  '<span class="sr-only">Processing...</span>' +
    		   '</div>';
	} 
	function dimmerTag(size, persist) {
		let persistClass = persist ? 'persist' : '';
		return '<div class="ui dimmer disabled inverted ajax ' + persistClass + '">' +
				  loaderTag(size, persistClass) +
			   '</div>';
	}

	return function loader(target, size, inside, persist) {
		let $target = $(target);
		$target.each(function () {
			let $this = $(this);
			let $loader = null;
			let content = dimmerTag(size, persist);
			if (inside) {
				$loader = $(content).appendTo($this);
			} else {
				$loader = $(content).insertBefore($this);
			}
			if ($this.is(':input')) {
				let isHorizontal = $this.closest('.form-horizontal').length !== 0;
				if (isHorizontal) {
					let width = $this.css('width');
					$loader.css('width', width);
				} 
			} else if (inside) {
				$loader.get(0).style.setProperty('bottom', '0', 'important');
			}
			$loader.fadeIn();
		});
    };

})();

function unpersistLoader() {
	$('.ajax.loader, .ajax.dimmer').removeClass('persist');
}

exports.escapeHtml = escapeHtml;
exports.asNumber = asNumber;
exports.showErrors = showErrors;
exports.removeErrors = removeErrors;
exports.showWarning = showWarning;
exports.showInfo = showInfo;
exports.removeWarning = removeWarning;
exports.removeInfo = removeInfo;
exports.removeFieldMsg = removeFieldMsg;
exports.createModel = createFormModel;
exports.restoreModel = restoreFormModel;
exports.modelVisitor = modelVisitor;
exports.Router = Router;
exports.loader = loader;
exports.unpersistLoader = unpersistLoader;


// WEBPACK FOOTER //
// ./js/aemps/aemps-form.js